import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { fetchCourse } from "../lib/api";

const CourseContext = createContext(null);

export function CourseProvider({ children }) {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCourse()
      .then(setCourse)
      .catch((e) => setError(e?.message || "Failed to load course"))
      .finally(() => setLoading(false));
  }, []);

  const totalTopics = useMemo(() => {
    if (!course) return 0;
    return course.modules.reduce((acc, m) => acc + (m.topics?.length || 0), 0);
  }, [course]);

  const value = { course, loading, error, totalTopics };
  return <CourseContext.Provider value={value}>{children}</CourseContext.Provider>;
}

export function useCourse() {
  const ctx = useContext(CourseContext);
  if (!ctx) throw new Error("useCourse must be used within CourseProvider");
  return ctx;
}
